import { useState } from "react";
import { toast } from "sonner";
import { Plus, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { api, errMsg } from "@/lib/api";

export const TypesDialog = ({ uid, types, onClose, onSaved }) => {
  const [custom, setCustom] = useState(types.filter((t) => t.custom));
  const [draft, setDraft] = useState({ label: "", color: "#22C55E" });
  const add = () => {
    if (!draft.label.trim()) return;
    setCustom([...custom, { key: draft.label.trim().toLowerCase().replace(/[^a-z0-9]+/g, "_"), label: draft.label.trim(), color: draft.color }]);
    setDraft({ label: "", color: draft.color });
  };
  const save = async () => {
    try {
      await api.put(`/universes/${uid}/relationship-types`, { types: custom });
      onSaved();
      onClose();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="rel-types-dialog">
        <DialogHeader><DialogTitle className="font-display text-3xl">Relationship types</DialogTitle></DialogHeader>
        <div className="space-y-4 py-2">
          <div className="flex flex-wrap gap-1.5">
            {types.filter((t) => !t.custom).map((t) => <span key={t.key} className="rounded-full border px-2.5 py-1 text-xs" style={{ borderColor: `${t.color}88`, color: t.color }}>{t.label}</span>)}
          </div>
          <div className="space-y-1.5">
            {custom.map((t, i) => (
              <div key={t.key} className="flex items-center gap-2" data-testid={`rel-custom-type-${t.key}`}>
                <input type="color" value={t.color} onChange={(e) => setCustom(custom.map((x, j) => (j === i ? { ...x, color: e.target.value } : x)))} className="h-8 w-10 cursor-pointer rounded border border-[#2D3442] bg-transparent" />
                <span className="flex-1 text-sm text-[#F3EBDD]">{t.label}</span>
                <Button size="icon" variant="ghost" onClick={() => setCustom(custom.filter((_, j) => j !== i))} data-testid={`rel-custom-type-remove-${t.key}`}><X className="h-4 w-4" /></Button>
              </div>
            ))}
          </div>
          <div className="flex items-center gap-2">
            <input type="color" value={draft.color} onChange={(e) => setDraft({ ...draft, color: e.target.value })} className="h-9 w-10 cursor-pointer rounded border border-[#2D3442] bg-transparent" data-testid="rel-new-type-color" />
            <Input value={draft.label} onChange={(e) => setDraft({ ...draft, label: e.target.value })} onKeyDown={(e) => e.key === "Enter" && add()} placeholder="New type, e.g. Sworn enemies" maxLength={40} data-testid="rel-new-type-input" />
            <Button size="icon" variant="ghost" onClick={add} data-testid="rel-new-type-add"><Plus className="h-4 w-4" /></Button>
          </div>
        </div>
        <DialogFooter><Button onClick={save} data-testid="rel-types-save">Save types</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
